import { useEffect, useState } from "react";

import "../assets/scss/components/_cookie-banner.scss";

export const CookieBanner = () => {
	const [canShow, setCanShow] = useState(false);
	const [accepted, setAccepted] = useState(false);

	useEffect(() => {
		if (typeof window === "undefined") return;
		const stored = window.localStorage.getItem("cookieBanner") === "accepted";
		setAccepted(stored);
		setCanShow(true);
	}, []);

	const handleAccept = () => {
		if (typeof window !== "undefined") {
			window.localStorage.setItem("cookieBanner", "accepted");
		}
		setAccepted(true);
	};

	if (!canShow || accepted) return null;

	return (
		<div className="cookie-banner">
			<p>We use cookies to improve your experience on our site. By using our site you consent cookies.</p>
			<button className="btn" onClick={handleAccept}>
				Accept
			</button>
		</div>
	);
};
